import { useAuth } from '../contexts/AuthContext';
import { NavigationBar } from './NavigationBar';
import { PublicLayout } from './PublicLayout';

/**
 * Dynamic layout component for form pages that switches between
 * public and authenticated layouts based on user authentication status
 */
interface FormLayoutProps {
	children: React.ReactNode;
}

function AuthenticatedFormLayout({ children }: { children: React.ReactNode }) {
	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900">
			<NavigationBar />
			<main className="py-8">{children}</main>
		</div>
	);
}

export function FormLayout({ children }: FormLayoutProps) {
	const { isAuthenticated } = useAuth();

	// For authenticated users, show the full navigation bar
	if (isAuthenticated) {
		return <AuthenticatedFormLayout>{children}</AuthenticatedFormLayout>;
	}

	// For unauthenticated users, use the clean PublicLayout
	return <PublicLayout>{children}</PublicLayout>;
}
